const isValidSection = require('../section');

module.exports = (funnel = {}, isLazy) =>
    !!funnel &&
    !!funnel.sections &&
    Object.values(funnel.sections)
        .map((curr) => isValidSection(curr, isLazy))
        .every(Boolean);
